_getVisibility